<div *ngIf="total" class="group-activity-bar__container">
  <div class="group-activity-bar chart-progress">
    <div class="chart-progress-item color-game-13" [ngStyle]="{ width: notStarted + '%' }"></div>
    <div class="chart-progress-item color-game-12" [ngStyle]="{ width: playing + '%' }"></div>
    <div class="chart-progress-item color-game-8" [ngStyle]="{ width: finished + '%' }"></div>
  </div>
  <div class="group-activity-bar__tooltip">
    <ul class="chart-list-colors padding-none">
      <li>
        <span class="color color-game-13"></span>
        <span class="label">{{ 'licenses.state.created' | translate }}: {{ licensesResume['created'] }}</span>
      </li>
      <li>
        <span class="color color-game-12"></span>
        <span class="label"
          >{{ 'licenses.state.playing' | translate }}:
          {{ licensesResume['beforeDemo'] + licensesResume['afterDemo'] }}</span
        >
      </li>
      <li>
        <span class="color color-game-8"></span>
        <span class="label">{{ 'licenses.state.completed' | translate }}: {{ licensesResume['completed'] }}</span>
      </li>
    </ul>
  </div>
</div>
